import { render, staticRenderFns } from "./BottomNavigationContainer.vue?vue&type=template&id=6ce772b5"
import script from "./BottomNavigationContainer.vue?vue&type=script&lang=js"
export * from "./BottomNavigationContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports